import React from "react";

const BillingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={16}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.75 4.75V3.95C0.75 2.83 0.75 2.27 0.968 1.842C1.16 1.465 1.465 1.16 1.842 0.968C2.27 0.75 2.83 0.75 3.95 0.75H15.55C16.67 0.75 17.23 0.75 17.657 0.968C18.034 1.16 18.34 1.465 18.532 1.842C18.75 2.269 18.75 2.829 18.75 3.947V4.75M0.75 4.75H18.75M0.75 4.75V11.55C0.75 12.67 0.75 13.23 0.968 13.658C1.15974 14.0343 1.46569 14.3403 1.842 14.532C2.269 14.75 2.829 14.75 3.947 14.75H15.553C16.671 14.75 17.23 14.75 17.657 14.532C18.034 14.34 18.34 14.034 18.532 13.658C18.75 13.23 18.75 12.672 18.75 11.554V4.75M3.75 10.75H7.75"
      stroke="white"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BillingIcon;
